/* eslint-disable @typescript-eslint/no-redeclare */
export const FETCH_CUSTOM_EXPORTS_LOADING = 'FETCH_CUSTOM_EXPORTS_LOADING';
export type FETCH_CUSTOM_EXPORTS_LOADING = typeof FETCH_CUSTOM_EXPORTS_LOADING;
export const FETCH_CUSTOM_EXPORTS_SUCCESS = 'FETCH_CUSTOM_EXPORTS_SUCCESS';
export type FETCH_CUSTOM_EXPORTS_SUCCESS = typeof FETCH_CUSTOM_EXPORTS_SUCCESS;
export const FETCH_CUSTOM_EXPORTS_FAILURE = 'FETCH_CUSTOM_EXPORTS_FAILURE';
export type FETCH_CUSTOM_EXPORTS_FAILURE = typeof FETCH_CUSTOM_EXPORTS_FAILURE;
